import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H3 } from 'foundations-components/transitional/components/H3';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function linkOverride(handleClick) {
  return props => /*#__PURE__*/_jsx("span", {
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
      children: props.children
    }))
  });
}
export function ModalErrorBoundary({
  actions,
  children
}) {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    identifier: "action-modal-error-boundary",
    fallback: /*#__PURE__*/_jsxs(Modal, {
      use: "conversational",
      size: "auto",
      children: [/*#__PURE__*/_jsx(DialogHeader, {
        children: /*#__PURE__*/_jsx(H3, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "errorStates.loading.title"
          })
        })
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(ErrorMessage, {
          illustration: "errors/general",
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "errorStates.loading.message_jsx",
              elements: {
                Link: linkOverride(() => {
                  window.location.reload();
                })
              }
            })
          })
        })
      }), /*#__PURE__*/_jsx(DialogFooter, {
        align: "center",
        children: /*#__PURE__*/_jsx(Button, {
          onClick: actions.close,
          use: "primary",
          type: "submit",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "common.cancel"
          })
        })
      })]
    }),
    children: children
  });
}